import { InputLabel, Typography } from '@mui/material'
import { DesktopDatePicker } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import { getIn } from 'formik'
import { FIELDS } from './field-names'

export interface FormikDateInputProps {
  // Formik fields, inherited from FastField / Field
  field: {
    value: string | number | Date | null
    name: keyof typeof FIELDS
  }
  form: {
    errors: Record<string, string>
    touched: Record<string, boolean>
    setFieldValue: (field: string, value: Date | null) => void
    submitCount: number
  }

  // Optional input properties
  label?: string
}

export const FormikDateInput = (props: FormikDateInputProps) => {
  const {
    field: { name, value },
    form: { touched, errors, setFieldValue, submitCount },
    label,
  } = props

  const hasErrorWithoutTouch = submitCount > 0
  const touchedOrSubmitted = getIn(touched, name) || hasErrorWithoutTouch
  const hasError = Boolean(touchedOrSubmitted && getIn(errors, name))

  return (
    <>
      <InputLabel sx={{ paddingTop: 2 }} error={hasError} htmlFor={name}>
        <Typography variant="caption" sx={{ marginBottom: 1 }}>
          {label}
          <Typography
            variant="caption"
            component="span"
            sx={{ paddingLeft: '2px', color: '#c62828' }}
          >
            *
          </Typography>
        </Typography>
      </InputLabel>
      <DesktopDatePicker
        value={value ? dayjs(value) : null}
        format="YYYY.MM.DD"
        onChange={(date: dayjs.Dayjs | null) => {
          if (date && date.isValid()) {
            setFieldValue(name, date.toDate())
          } else if (date === null) {
            setFieldValue(name, null)
          }
        }}
        slotProps={{
          textField: {
            fullWidth: true,
            error: hasError,
            helperText: touchedOrSubmitted && getIn(errors, name),
          },
        }}
      />
    </>
  )
}
